import React from 'react';
import { Modal, Progress } from 'antd';
import { imagePath } from '@common/services/images-service';
import { Colors } from '@common/tokens';

export const FullScreenLoadingModal = ({
  open,
  description,
  progress,
}: {
  open: boolean;
  description: string;
  progress?: number;
}) => {
  const showProgress = progress !== undefined;

  return (
    <>
      <Modal
        centered
        open={open}
        bodyStyle={{ padding: '0' }}
        maskStyle={{ backgroundColor: Colors.elmHyperlight }}
        footer={null}
        maskClosable={false}
        closable={false}
        className="rates-page-loading"
      >
        <div className="rates-page-loading__body">
          <span className="trusted-icon">
            <img src={imagePath('./works-logo-elm.svg')} />
          </span>
          <div className="loader-icon">
            <img src={imagePath('./loading-beat.gif')} />
          </div>
          {showProgress && (
            <Progress
              strokeColor={Colors.elm}
              status="active"
              percent={progress}
              className="progress-bar"
            />
          )}
          <div className="footer">
            <span>{description}</span>
          </div>
        </div>
      </Modal>
      <style jsx>{`
        :global(.rates-page-loading .ant-modal-content) {
          border: 1px solid ${Colors.elmLightest};
          border-radius: 16px;
          box-shadow: none;
        }

        :global(.rates-page-loading .rates-page-loading__body .progress-bar) {
          margin-bottom: 20px;
        }

        :global(.rates-page-loading__body) {
          padding: 44px;
          display: flex;
          flex-direction: column;
          align-items: center;
          position: relative;
        }

        :global(.rates-page-loading__body .trusted-icon) {
          position: absolute;
          top: -110px;
        }

        :global(.rates-page-loading__body .loader-icon) {
          display: flex;
          justify-content: center;
        }

        :global(.rates-page-loading__body .loader-icon img) {
          width: 210px;
          height: 210px;
        }

        :global(.rates-page-loading__body .footer) {
          display: flex;
          justify-content: center;
        }
      `}</style>
    </>
  );
};
